export default __webpack_public_path__ + "static/media/Silver_MV_final.7e3c1713.jpg";